import { render, staticRenderFns } from "./KT-BarPieChart.vue?vue&type=template&id=7678d8a9&scoped=true&lang=pug&"
import script from "./KT-BarPieChart.vue?vue&type=script&lang=js&"
export * from "./KT-BarPieChart.vue?vue&type=script&lang=js&"
import style0 from "./KT-BarPieChart.vue?vue&type=style&index=0&id=7678d8a9&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7678d8a9",
  null
  
)

export default component.exports